import { FC, useState } from 'react';
import { useClickAway } from 'hooks/useClickAway';
import MovablePlaceholder from '../MovablePlaceholder/MovablePlaceholder';
import TimePicker from '../TimePicker/TimePicker';
import { ValidationBody } from 'ts/interfaces/Validation';
import withErrorBoundary from 'components/ui/withErrorBoundaries';

interface FormGroupTimePickerProps {
  value?: Date;
  onChange: (value: Date) => void;
  movablePlaceholder?: string;
  movablePlaceholderIcon?: any;
  label?: string;
  className?: string;
  isSubmitted?: boolean;
  validation?: ValidationBody;
}

const FormGroupTimePicker: FC<FormGroupTimePickerProps> = (props) => {
  const [open, setOpen] = useState(false);
  const timeRef = useClickAway(() => setOpen(false));

  const formatTimeNumber = (time?: number) => {
    if (!time) return '00';
    if (time < 10) {
      return `0${time}`;
    }
    return time.toString();
  };

  return (
    <div className={props.className}>
      <div className={'form-group mb-0'}>
        {props.label && (
          <label>
            {props.label} {props.validation?.required && <span className="color-danger">*</span>}
          </label>
        )}
        <div
          className={`rtl-text-fix form-control ${
            props.movablePlaceholder ? 'movable-placeholder-input' : ''
          }`}
          onClick={() => setOpen(true)}
        >
          {formatTimeNumber(props.value?.getHours())} :{' '}
          {formatTimeNumber(props.value?.getMinutes())}
        </div>

        {!!props.movablePlaceholder && (
          <MovablePlaceholder
            label={props.movablePlaceholder}
            showSmall={open || !!props.value}
            icon={props.movablePlaceholderIcon}
          />
        )}

        {open && (
          <div ref={timeRef}>
            <TimePicker onChange={props.onChange} value={props.value} />
          </div>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(FormGroupTimePicker, 'FormGroupTimePicker');
